/** */
import { urls } from 'services/_url';
import { apiDelete, apiGet, apiPost } from 'services/_http';

/** */
const base_url = `${urls.agents}/v1/word-searches`;
const agent_url = `${urls.agents}/v1/agent`;

export const read = async (options = {}) => {
  return await apiGet(`${base_url}`, { ...options });
};

export const readById = async (id, options = {}) => {
  return await apiGet(`${base_url}/${id}`, { ...options });
};

export const search = async (keys, keyword, options = {}) => {
  const query_string = options.query_string
    ? `${options.query_string}&keyword=${keyword}`
    : `keyword=${keyword}`;
  return await apiGet(`${base_url}/search/${keys}`, {
    ...options,
    query_string
  });
};

export const deleteOne = async (id, options = {}) => {
  return await apiDelete(`${base_url}/${id}`, { ...options });
};

export const generate = async (options = {}) => {
  return await apiPost(`${agent_url}/content/word-search/run`, { ...options });
};
